export enum ArgusSyncOptionEnum {
  NewValuation = 1,
  CopyOfExistingValuation,
  UpdateValuation
}
